export default __webpack_public_path__ + "static/portfolio_gallery_26-439a920dc69ae727c0192fcf264ac626.jpg";